import { render, staticRenderFns } from "./BulkUploader.vue?vue&type=template&id=6ada1266"
import script from "./BulkUploader.vue?vue&type=script&lang=ts"
export * from "./BulkUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports